<template>
  <div v-if="isOpen" class="modal-backdrop">
    <div class="modal-container" @click.stop>
      <div class="modal-content">
        <p class="modal-message">{{ message }}</p>
        <div class="button-container">
          <button @click="handleNo">戻る</button>
          <button @click="handleYes">OK</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "MessageModalComponent",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  emits: ["response"],
  methods: {
    handleYes() {
      this.$emit("response", true);
    },
    handleNo() {
      this.$emit("response", false);
    },
  },
});
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-container {
  background: white;
  padding: 20px;
  border-radius: 5px;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 40%; /* モーダルの幅を設定 */
  height: 50%;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
}

.modal-content {
  flex: 1; /* 残りのスペースを占める */
  border-width: 0px;
  margin: 0 auto; /* 中央寄せ */
  flex-direction: column;
  display: flex;
}

.modal-message {
  margin-top: 10%;
  margin-bottom: auto; /* ボタンの上までスペースを広げる */
  font-size: 1.5em; /* フォントサイズを大きくする */
  text-align: center;
  flex-grow: 1; /* メッセージ部分を伸ばして中央に配置 */
  display: flex;
  justify-content: center;
  white-space: pre-line; /* 改行を反映 */
}

.button-container {
  display: flex;
  justify-content: space-between; /* ボタンの間隔を広げる */
  width: 100%;
  padding: 0 20px; /* モーダルフォームの両側に余白を作成 */
  position: absolute;
  bottom: 20px; /* モーダルフォームの下辺からの距離 */
}

button {
  margin: 0 10px; /* 上下のマージンは0、左右のマージンを10pxに設定 */
  width: 150px;
  height: 40px;
  border-radius: 10px;
}
</style>
